export const STORAGE = {
  ACCESS_TOKEN: 'accessToken',
  FILTERS: 'filters',
  LANGUAGES: 'languages',
  USER: 'user'
};
